export enum EnvelopeRelativeMode {
  Average = 0,
  Maximum = 1,
  Minimum = 2,
  Absolute_Maximum = 3,
  Absolute_Minimum = 4,
}
